import React, { useEffect, useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { FaFacebookF } from 'react-icons/fa';
import { Button, Checkbox, FormControlLabel, FormGroup, TextField } from '@mui/material';

import { WavingHand as WavingHandIcon } from '@mui/icons-material';

import { SignInOrLoginRow } from './SignInOrLoginRow.js';

import NavBar from '../NavBar.js';
import { Footer } from '../Footer/Footer.js';

import { Loader } from '../Elements/Loader.js';
import { Label } from '../Elements/Label.js';
import { useLocalStorage } from '../../CustomHooks/useLocalStorage';

import { signingUpUser, signUpUser, getCsrfToken } from '../../actions';
import { getOrSetAnonymousUserId } from '../../utils/index.js';

import { TOKEN, API_ENDPOINT } from '../../constants';

import {
  SIGN_UP,
  SIGN_UP_FORM_ROWS,
  EMPOWER_YOUR_FINANCIAL_DECISIONS,
  WELCOME,
  SIGN_UP_TRACKING_NAME,
  SIGN_UP_WITH_GOOGLE,
  SIGN_UP_WITH_FACEBOOK,
} from '../../constants/Forms';

import './SignUp.css';

import SignUpImg from './Finance-Loan-Trade-Mortgage.png';

export const SignUp = () => {
  const [userId, setUserId] = useState('');
  const [termsAndConditionsChecked, setTermsAndConditionsChecked] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    getValues,
  } = useForm();
  const dispatch = useDispatch();
  const { loading, jwt, csrfToken } = useSelector(
    ({ userReducer: { loading, jwt, csrfToken } }) => ({
      loading,
      jwt,
      csrfToken,
    }),
  );

  const navigate = useNavigate();
  const [value] = useLocalStorage(TOKEN);
  const anonymousId = getOrSetAnonymousUserId();

  useEffect(() => {
    if (!csrfToken) {
      dispatch(getCsrfToken());
    }
  }, [csrfToken]);

  useEffect(() => {
    // Redirect to the dashboard page
    if (jwt || value) {
      if (!localStorage.getItem(TOKEN)) {
        return;
      }
      const user = atob(localStorage.getItem('token')?.split('.')?.[1]);

      if (JSON.parse(user)) {
        navigate('/dashboard');
      } else {
        setUserId(anonymousId);
      }
    } else {
      setUserId(anonymousId);
    }
  }, [value, jwt]);

  const handleOnUpKeyMixPanelTracking = (formField) => {
    mixpanel.track('Sign Up Form', {
      [formField]: getValues(formField) || formField,
      path: '/signup',
      distinct_id: userId,
    });
  };

  const onSubmit = async (data) => {
    mixpanel.track('Sign Up Form', {
      action: 'Submit',
    });
    dispatch(signingUpUser);
    dispatch(
      signUpUser({
        user: { ...data, firstname: data.firstName, lastname: data.lastName },
        csrfToken,
      }),
    );
    // setTimeout(() => {
    //   // gtag_report_conversion('/signup');
    // }, 4500);
  };

  const handleGoogleSignUp = () => {
    mixpanel.track('Google Auth Sign Up', {
      path: '/auth/google',
      distinct_id: userId,
    });
    window.location.href = `${API_ENDPOINT}/auth/google`;
    // gtag_report_conversion(`${API_ENDPOINT}/auth/google`);
  };

  const handleFacebookSignUp = () => {
    mixpanel.track('Facebook Auth Sign Up', {
      path: '/auth/facebook',
      distinct_id: userId,
    });
    window.location.href = `${API_ENDPOINT}/auth/facebook`;
    // gtag_report_conversion(`${API_ENDPOINT}/auth/facebook`);
  };

  return (
    <>
      <NavBar currentPath="" />
      <div className="sign-up-wrapper">
        <header className="login-header-wrapper">
          <div className="sign-up-log-in-image-wrapper">
            <img src={SignUpImg} className="sign-up-log-in-image" />
          </div>
          <form className="sign-up-form" onSubmit={handleSubmit(onSubmit)}>
            <h5 className="login-header">
              {WELCOME} <WavingHandIcon className="waving-hand-icon" />
            </h5>{' '}
            <p className="header-detail-paragraph">{EMPOWER_YOUR_FINANCIAL_DECISIONS}</p>
            <SignInOrLoginRow currentForm={SIGN_UP} userId={userId} />
            {Object.keys(SIGN_UP_FORM_ROWS).map((row) => {
              const leftColumn = SIGN_UP_FORM_ROWS?.[row]?.[0];
              const rightColumn = SIGN_UP_FORM_ROWS?.[row]?.[1];
              return (
                <div className="sign-up-form-row" key={leftColumn.label}>
                  <div
                    className="sign-up-form-row-left"
                    style={{ width: `${100 / SIGN_UP_FORM_ROWS?.[row]?.length}%` }}
                  >
                    <TextField
                      className={leftColumn?.className}
                      error={!!errors[leftColumn?.name]}
                      helperText={errors[leftColumn?.name]?.message}
                      id={leftColumn?.id}
                      placeholder={leftColumn?.label}
                      name={leftColumn?.name}
                      autoComplete="off"
                      {...register(leftColumn?.name, {
                        required: leftColumn?.required,
                        pattern: { ...leftColumn.pattern },
                      })}
                      variant="outlined"
                      sx={{ backgroundColor: 'rgb(240, 240, 240)', borderRadius: '10px' }}
                      type={leftColumn?.type}
                      onKeyUp={(e) => {
                        if (SIGN_UP_TRACKING_NAME[e.target.name]) {
                          handleOnUpKeyMixPanelTracking(SIGN_UP_TRACKING_NAME[e.target.name]);
                        }
                      }}
                    />{' '}
                    <br />
                  </div>
                  {rightColumn && (
                    <div className="sign-up-form-row-right">
                      <TextField
                        className={rightColumn?.className}
                        error={!!errors[rightColumn?.name]}
                        id={rightColumn?.id}
                        autoComplete="off"
                        helperText={errors[rightColumn?.name]?.message}
                        name={rightColumn?.name}
                        placeholder={rightColumn?.label}
                        variant="outlined"
                        sx={{ backgroundColor: 'rgb(240, 240, 240)', borderRadius: '10px' }}
                        {...register(rightColumn?.name, {
                          required: rightColumn?.required,
                        })}
                        type={rightColumn?.type}
                        onKeyUp={(e) => {
                          if (SIGN_UP_TRACKING_NAME[e.target.name]) {
                            handleOnUpKeyMixPanelTracking(SIGN_UP_TRACKING_NAME[e.target.name]);
                          }
                        }}
                      />{' '}
                      <br />
                    </div>
                  )}
                </div>
              );
            })}
            <FormGroup>
              <FormControlLabel
                required
                control={
                  <Checkbox
                    checked={termsAndConditionsChecked}
                    onChange={(e) => {
                      setTermsAndConditionsChecked(e.target.checked);
                      handleOnUpKeyMixPanelTracking('CheckBox ' + e.target.checked);
                    }}
                  />
                }
                label={<Label />}
              />
            </FormGroup>
            <div className="signup_button_wrapper">
              <Button
                type="submit"
                variant="outlined"
                sx={{
                  '&:hover': { backgroundColor: 'black', color: 'white' },
                  m: 0,
                  color: 'white',
                  textTransform: 'initial',
                  backgroundColor: 'black',
                  width: '100%',
                  borderRadius: 2,
                  mr: '3px',
                  height: '48px',
                  marginBottom: '20px',
                  marginBottom: '5px',
                  mt: '15px',
                }}
                disabled={loading}
              >
                {loading ? <Loader /> : SIGN_UP}
              </Button>
            </div>
            <Button
              variant="outlined"
              className="googleBtn"
              onClick={handleGoogleSignUp}
              startIcon={
                <img
                  src="https://developers.google.com/identity/images/g-logo.png"
                  alt="Google"
                  width="18"
                  height="18"
                />
              }
            >
              {SIGN_UP_WITH_GOOGLE}
            </Button>
            <Button
              variant="contained"
              className="facebookBtn"
              onClick={handleFacebookSignUp}
              startIcon={<FaFacebookF />}
            >
              {SIGN_UP_WITH_FACEBOOK}
            </Button>
          </form>
        </header>
        <div className="sign-up-log-in-image-wrapper-mobile">
          <img src={SignUpImg} className="sign-up-log-in-image" />
        </div>
      </div>
      <Footer currentPath={'/signup'} />
    </>
  );
};
